import { ReactNode, useState } from "react";
import styles from "./statisticFormat.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { CiFilter } from "react-icons/ci";
import { FaFileCsv, FaFilePdf } from "react-icons/fa6";

import AllDataFilterPopup from "pages/statistic/statisticPopup/allDataFilterPopup";

interface StatisticTabbarProps {
    label: string;
    description: string;
    children: ReactNode;
    onFilterButton1Click?: () => void;
    onCsvButton1Click: (label: string, description: string) => void;
    onPdfButton1Click: (label: string, description: string) => void;
}

export default function StatisticTabbar({
    label,
    description,
    children,
    onFilterButton1Click,
    onCsvButton1Click,
    onPdfButton1Click,

}: StatisticTabbarProps) {
    
    const [isAllDataFilterPopupOpen, setIsAllDataFilterPopupOpen] = useState(false);

    return (
        <>
            <AllDataFilterPopup isPopupOpen={isAllDataFilterPopupOpen} onClose={() => setIsAllDataFilterPopupOpen(false)} />

            <div className={styles.StatisticFormatContainer}>
                <div className={styles.statistikContaint}>
                    <div className={styles.headerRow}>
                        <span className={styles.description}>{description}</span>
                        <span className={styles.label}>{label}
                        </span>
                    </div>

                    <div className={styles.statChildContainer}>{children}</div>
                </div>



                <div className={styles.buttonsContainer}>
                    {onFilterButton1Click && <button
                        className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => onFilterButton1Click()}
                    >
                        <CiFilter /> Filter
                    </button>}
                    <button
                        className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => onPdfButton1Click(label, description)}
                    >
                        <p> <FaFilePdf />  Auswertung herunterladen (pdf)</p>
                    </button>
                    <button
                        className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => onCsvButton1Click(label, description)}
                    >
                        <p>< FaFileCsv />  Auswertung  herunterladen (csv)</p>
                    </button>


                    <button className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => setIsAllDataFilterPopupOpen(true)}

                    >
                        Alle Daten herunterladen
                    </button>
                </div>
            </div>
        </>
    );
}
